import { GetNotificationTemplateQuery } from "gql/graphql";
import { NotificationForm } from "@/modules/admin-panel/notification-templates/shared/notification-form";

export const getNotificationTemplateQueryToNotificationTemplateValueInput = (
  data?: GetNotificationTemplateQuery,
) => {
  const value = data?.getNotificationTemplateById.value;

  return {
    code: data?.getNotificationTemplateById.code ?? "",
    ...(value
      ? NotificationForm.transformers.notificationTemplateValueDtoToNotificationTemplateInput(
          value,
        )
      : {}),
  };
};
